export default __webpack_public_path__ + "static/cursor-444cb9af100e3776f29abdb2ac174aab.png";